import {Offer, Product} from "../domain";

const firstAvailableVariantInOffer = (product: Product, offer: Offer) => {
  const offerProduct = offer?.products?.find(
    (p) => p.shopify_product_handle === product?.handle,
  );
  const availableProductVariants = product?.variants?.filter(
    (v) => v.available,
  );
  return availableProductVariants?.find((v) =>
    offerProduct?.shopify_product_variants.includes(v.id),
  );
}

export default firstAvailableVariantInOffer
